import clsx from 'clsx';
import React from 'react';
import { PopoverWrapper, PopoverContainerWrapper, Arrow } from './styles';
import { PositionTypes } from './styles/models';

export type PopoverProps = {
  visible?: boolean;
  /**
   * Attribute to define the width of the popover
   */
  size?: number;
  /**
   * Attribute to define background color of the popover
   */
  backgroundColor?: string;
  /**
   * Attribute to define position of the popover
   */
  place?: PositionTypes;
  /**
   * Attribute to define CSS styles
   */
  style?: React.CSSProperties;
  /**
   * Attribute to correct the tooltip position based on device width
   */
  correctTooltipPosition?: string;
};

export const defaultProps: PopoverProps = {
  visible: false,
  size: 100,
  backgroundColor: '#ffffff',
  place: 'bottom-right',
  style: {},
};

export const PopoverContainer: React.FC = ({ children }) => (
  <PopoverContainerWrapper>{children}</PopoverContainerWrapper>
);

const Popover: React.FC<PopoverProps> = ({
  children,
  place,
  visible,
  correctTooltipPosition,
  backgroundColor,
  ...otherProps
}) => {
  return (
    <>
      <PopoverWrapper
        id={'tool-tip'}
        data-testid="popover"
        className={clsx(place, { visible })}
        backgroundColor={backgroundColor}
        {...otherProps}
        correctTooltipPosition={correctTooltipPosition}
      >
        {children}
      </PopoverWrapper>
      <Arrow className={clsx(place, { visible })} backgroundColor={backgroundColor}></Arrow>
    </>
  );
};

Popover.defaultProps = defaultProps;

export default Popover;
